var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsString, IsUUID } from 'class-validator';
export class OfficeLocationBrandingResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    officeId;
    logoFile;
    primaryColor;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBrandingResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBrandingResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBrandingResponseDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBrandingResponseDto.prototype, "logoFile", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBrandingResponseDto.prototype, "primaryColor", void 0);
//# sourceMappingURL=office-location-branding.response.dto.js.map